import React, { Component } from 'react';
import { defaultHeaders } from './util';
import './stars.css';

export class StaticStars extends Component{
  constructor(props){
    super(props);
    this.getProductRating = this.getProductRating.bind(this);
    this.state = {
      ratingAverage: -1,
      count: 0,
      uuid: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.uuid !== undefined && nextProps.uuid !== null && nextProps.uuid !== '' && nextProps.uuid !== this.state.uuid) {
      this.setState({uuid: nextProps.uuid});
      this.getProductRating(nextProps.uuid);
    }
  }

  getProductRating(uuid) {
    const self = this;
    const url = `/api/get-rating?uuid=${uuid}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    fetch(url, {method: 'GET',
                              mode: 'cors',
                              headers: headers
    })
      .then( response => response.json() )
      .catch(function(exception) {
        alert('Durchschnittliche Bewertung konnte nicht geladen werden.');
        console.error('Could not load product rating average.', exception);
      })
      .then( function(json) {
        self.setState({ratingAverage: json.round, count: json.count});
      });
    return true;
  }

  render() {
    return (
      <div className="StaticStars VerticalAlignmiddle" title="Durchschnittliche Bewertung"  style={{textAlign: 'left'}}  >
        <h2>
          <span className="StarStatic" style={this.state.ratingAverage > 0 ? {color: '#1F6A81'} : {color: 'lightgrey'}}>&#9733;</span>
          <span className="StarStatic" style={this.state.ratingAverage > 1 ? {color: '#1F6A81'} : {color: 'lightgrey'}}>&#9733;</span>
          <span className="StarStatic" style={this.state.ratingAverage > 2 ? {color: '#1F6A81'} : {color: 'lightgrey'}}>&#9733;</span>
          <span className="StarStatic" style={this.state.ratingAverage > 3 ? {color: '#1F6A81'} : {color: 'lightgrey'}}>&#9733;</span>
          <span className="StarStatic" style={this.state.ratingAverage > 4 ? {color: '#1F6A81'} : {color: 'lightgrey'}}>&#9733;</span>
        </h2>
        {this.state.count !== undefined && this.state.count >= 1 ? <div>{this.state.ratingAverage}/5 bei {this.state.count} {this.state.count === 1 ? 'Bewertung' : 'Bewertungen'}</div> : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/static-stars.js